<div class="user-detail-main px-4 mb-5">
  <div class="row mt-4 mb-2">
    <div class="col-lg-12 col-xl-2">
      <div class="avatar-container text-center text-lg-left">
        <span class="avatar-box pointer-cursor">
          <img
            class="img-fluid"
            src="assets/svg/ico-accesspoint-transparent.svg"
          />
        </span>
      </div>
    </div>
    <div class="col-lg-12 col-xl-10">
      <div class="row">
        <div
          class="col-12 main-heading justify-content-lg-between justify-content-center text-lg-left text-center d-flex"
        >
          <div class="d-flex overflow-ellipsis">
            <app-with-tooltip class="overflow-ellipsis" [showHelpCursor]="true">
              {{ 'ACCESS_POINT' | translate }} {{ accessPointName }}
            </app-with-tooltip>
          </div>
          <div class="position-relative b-10">
            <button
              type="button"
              class="add-user btn outline-none pointer-cursor float-right"
            >
              <img src="assets/svg/ico-lock-access-settings.svg" />
            </button>
          </div>
        </div>
      </div>

      <div class="row">
        <div class="col-lg-5">
          <div class="col-11 setting-icon">
            <div class="row justify-content-between mt-2">
              <div
                *ngIf="accessPointFloorName"
                class="col-6 col-lg-6 justify-content-center d-flex cursor-default"
              >
                <img src="assets/svg/ico-floors-circle.svg" class="icon" />
                <span class="pl-2 pt-1 text d-flex flex-column col-8">
                  <span class="title">
                    <app-with-tooltip [showHelpCursor]="true">
                      {{ accessPointFloorName }}
                    </app-with-tooltip>
                  </span>
                  <p class="sub-title">
                    {{ 'FLOOR' | translate }}
                  </p>
                </span>
              </div>
              <div
                *ngIf="accesspointDeviceCount"
                class="col-6 col-lg-6 justify-content-center d-flex m-auto cursor-default"
              >
                <img src="assets/svg/ico-lock-circle.svg" class="icon" />
                <span class="ml-2 mt-1 text d-flex flex-column">
                  <span class="title">
                    <app-with-tooltip [showHelpCursor]="true">
                      {{ accesspointDeviceCount }}
                    </app-with-tooltip>
                  </span>
                  <p class="sub-title">
                    {{ 'DEVICE' | translate }}
                  </p>
                </span>
              </div>
            </div>
          </div>
        </div>

        <div class="col-lg-6 py-1">
          <div class="col-12 setting-icon">
            <div class="row justify-content-between mt-2">
              <div
                *ngIf="buildingName"
                class="col-6 col-lg-4 justify-content-center offset-lg-2 d-flex cursor-default ml-4"
              >
                <img
                  src="assets/svg/ico-building-with-black-circle.svg"
                  class="icon"
                />
                <span class="pl-2 pt-1 text d-flex flex-column col-12">
                  <span class="title">
                    <app-with-tooltip [showHelpCursor]="true">
                      {{ buildingName }}
                    </app-with-tooltip>
                  </span>
                  <p class="sub-title">
                    {{ 'BUILDING' | translate }}
                  </p>
                </span>
              </div>
              <div
                *ngIf="accesspointWingName"
                class="col-6 col-lg-4 justify-content-center offset-lg-2 d-flex cursor-default"
              >
                <img src="assets/svg/ico-directions-circle.svg" class="icon" />
                <span class="pl-2 pt-1 text d-flex flex-column col-10">
                  <span class="title">
                    <app-with-tooltip [showHelpCursor]="true">
                      {{ accesspointWingName }}
                    </app-with-tooltip>
                  </span>
                  <p class="sub-title">
                    {{ 'WING' | translate }}
                  </p>
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <ng-container>
    <div
      class="w-100 pt-3 user-detail-body content position-relative app-scrollbar"
    >
      <ul
        ngbNav
        #nav="ngbNav"
        [(activeId)]="activeTab"
        class="nav-tabs w-100 mb-3"
        [class.tab-disabled]="disabledDeviceTab && disabledUserTab"
      >
        <li
          ngbNavItem="deviceTab"
          [disabled]="disabledDeviceTab"
          [class.not-allowed]="disabledDeviceTab"
        >
          <a ngbNavLink class="pointer-cursor">{{ 'DEVICE' | translate }}</a>
          <ng-template ngbNavContent>
            <div class="access-user-container" *ngIf="!disabledDeviceTab">
              <!-- lock devices start -->
              <!-- getPartnerDeviceLockImg(device?.deviceState) -->
              <app-shared-access-point-list
                [deviceList]="deviceList"
              ></app-shared-access-point-list>
              <!-- lock devices end -->
            </div>

            <app-device-not-found
              *ngIf="
                disabledDeviceTab &&
                disabledUserTab &&
                this.deviceList?.length + (this.usersList | async)?.length === 0
              "
            ></app-device-not-found>
          </ng-template>
        </li>
        <li
          ngbNavItem="userTab"
          [disabled]="disabledUserTab"
          [class.not-allowed]="disabledUserTab"
        >
          <a ngbNavLink class="pointer-cursor">{{ 'USERS' | translate }}</a>
          <ng-template ngbNavContent>
            <app-shared-unit-users-list
              [usersList]="usersList"
            ></app-shared-unit-users-list>
          </ng-template>
        </li>
      </ul>
      <div [ngbNavOutlet]="nav" class="mt-2"></div>
    </div>
  </ng-container>
</div>
